/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import './styles.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Button as ButtonUi, Modal, Typography } from '@material-ui/core';
import axios from 'axios';
import { showMessageSuccess } from '../others/toastr';
import {
    inscricaoBodyTemplate,
    nomeBodyTemplate,
    telefoneBodyTemplate,
    CPFBodyTemplate,
    subGrupoTemplate,
    statusBodyTemplate,
    ProgressSrinnerUpSell,
    statusAceiteBodyTemplate
} from './formatacaoTabela';
import { buscarContratoUpSellPorInscricao, buscarContratoUpsellPorVendedor, verificarPlanosElegiveis } from '../../services/upSell';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import ModalPlanosCompativeis from './modal';
import getTipoColaborador from '../../helpers/getTipoColaborador';
import { useHistory } from 'react-router-dom';
import { cadastrarEAtualizarContratosUpsel, mensagemSweetAlertWarning, statusEnum } from './funcoesUpSell';

function ListarUpSell() {
    const [permissao, setPermissao] = useState();
    const [contratos, setContratos] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingBuscaIncricao, setLoadingBuscaIncricao] = useState(false);
    const [dadosBuscaContrato, setDadosBuscaContrato] = useState('');
    const [openModalPlanos, setOpenModalPlanos] = useState(false);
    const [dadosVendedor, setDadosVendedor] = useState({});
    const [nomeBotaoTabela, setNomeBotaoTabel] = useState('');
    const [contratoSelecionado, setContratoSelecionado] = useState('');
    const [titulo, setTitulo] = useState('Meus contratos (UpSell)');
    const [isInscricao, setInscricao] = useState();
    const history = useHistory();
    const STATUS_FORBIDDEN = 403;
    const CONFLICT = 409;
    const ACCEPTED = 202;
    const NOTFOUND = 404;
    const SUCESSO = 200;
    const nomeBotaoIniciarUpSell = 'Iniciar UpSell';
    const nomeBotaoPlanosCompativeis = 'Planos compatíveis';
    const nomeBotaoVisualizarPosVenda = 'Pós vendas';

    useEffect(() => {
        const codigoVendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;

        if (!codigoVendedor) {
            history.push('/');
        }

        setIsLoading(true);

        const tipoColaborador = getTipoColaborador(decriptObjectOnLocalStorage('PERM'));

        setPermissao(tipoColaborador);

        (async () => {
            try {
                setDadosVendedor({
                    tipoColaborador,
                    codigoVendedor
                });

                const planosVinculadoVendedor = await buscarContratoUpsellPorVendedor(tipoColaborador, codigoVendedor);

                if (planosVinculadoVendedor.status === SUCESSO) {
                    setContratos(planosVinculadoVendedor.data);
                    setNomeBotaoTabel(nomeBotaoPlanosCompativeis);
                }

                setIsLoading(false);
            } catch (error) {
                throw new Error('Erro ao buscar plnos por vendedor!');
            }
        })();
    }, [openModalPlanos]);

    const buscaContratos = async dadosBusca => {
        try {
            setLoadingBuscaIncricao(true);

            if (!isNaN(+dadosBusca) && /^\d+$/.test(dadosBusca)) {
                const response = await buscarContratoUpSellPorInscricao(dadosVendedor.codigoVendedor, permissao, dadosBusca.trim());

                if (response instanceof Error) {
                    throw response;
                }

                const contratoEncontrado = response?.data;

                if (contratoEncontrado) {
                    if (contratoEncontrado.vendedor) {
                        mensagemSweetAlertWarning('Este contrato já se encontra inicializado em sua lista de contratos UpSell');
                        setTimeout(() => {
                            window.location.reload();
                        }, 6000);

                        return;
                    }

                    const codIBGE = contratoEncontrado.cidade;
                    const plano = contratoEncontrado.subGrupo;
                    const areaAtuacao = decriptoLocalStorage('area')?.decriptoValue;
                    const existePlanosElegiveis = await verificarPlanosElegiveis(codIBGE, plano, areaAtuacao, dadosBusca);

                    if (existePlanosElegiveis?.data?.length > 1) {
                        setContratos([contratoEncontrado]);
                        setNomeBotaoTabel(nomeBotaoIniciarUpSell);
                        setTitulo('Contrato sem inicialização (UpSell)');
                    } else {
                        mensagemSweetAlertWarning('O lead é elegível mas não possui planos elegíveis na cidade atual!');
                    }
                }
            } else {
                mensagemSweetAlertWarning('Formato de inscrição inválido!');
            }

            setDadosBuscaContrato('');
            setLoadingBuscaIncricao(false);
        } catch (error) {
            setLoadingBuscaIncricao(false);

            if (axios.isAxiosError(error)) {
                const status = error?.response?.status;

                switch (status) {
                    case CONFLICT:
                        mensagemSweetAlertWarning('Este contrato encontra-se atribuido a outro vendedor!');
                        break;
                    case STATUS_FORBIDDEN:
                        mensagemSweetAlertWarning('Voce não tem permissão a buscar no UpSell!');
                        break;
                    case NOTFOUND:
                        mensagemSweetAlertWarning(error?.response?.data?.mensage);
                        break;
                    default:
                        mensagemSweetAlertWarning('Erro ao buscar contrato, por favor tente novamente!');
                }
            }

            setDadosBuscaContrato('');
        }
    };

    const renderHeader = () => (
        <div className="p-grid p-fluid DatatableHeader">
            <div className="p-col-3 p-md-3 buscaPorInscricao">
                {loadingBuscaIncricao && <i className="pi pi-spin pi-spinner loadingBuscaPorInscricao" />}
                <InputText
                    type="search"
                    value={dadosBuscaContrato}
                    icon='pi pi-spinner'
                    classID='input-inscricao'
                    placeholder="Buscar por Inscrição."
                    onChange={e => setDadosBuscaContrato(e.target.value)}
                />
            </div>
            <div className='p-col-2 p-md-2'>
                <Button
                    className='p-button-raised p-button-secondary botaoBuscarContratos'
                    icon='pi pi-search'
                    label='Buscar'
                    onClick={() => buscaContratos(dadosBuscaContrato)}
                />
            </div>
        </div>
    );

    const handleCloseModal = () => {
        setContratos([]);
        setDadosBuscaContrato('');
        setOpenModalPlanos(false);
    };

    const IniciarUpSellCompararPlanos = async rowData => {
        if (nomeBotaoTabela === nomeBotaoIniciarUpSell) {
            setIsLoading(true);

            const response = await cadastrarEAtualizarContratosUpsel(rowData, dadosVendedor);

            if (response?.status === ACCEPTED) {
                showMessageSuccess('Sucesso', 'UpSell iniciado com sucesso!', 'toast-top-center');
                setTitulo('Meus contrato (UpSell)');
                setNomeBotaoTabel(nomeBotaoPlanosCompativeis);
            } else if (response) {
                setNomeBotaoTabel(nomeBotaoPlanosCompativeis);
            }

            setIsLoading(false);
        } else {
            setOpenModalPlanos(true);
            setContratoSelecionado(rowData);
        }

        setInscricao(rowData?.inscricao);
    };

    const telaComparacaoPosVendas = async ({ inscricao, subGrupoDestino }) => {
        if (!subGrupoDestino) {
            return mensagemSweetAlertWarning('Erro ao processar a solicitação.  Tente novamente ou contate o suporte se o problema persistir.');
        }

        history.push({
            pathname: `/up-sell/comparativo/${inscricao}`,
            state: { planoMigrado: true }
        });
    };

    const buttonBodyTemplate = rowData => {
        const contratoMigrado = rowData.status === statusEnum.migrado;
        const nomeBotao = contratoMigrado ? nomeBotaoVisualizarPosVenda : nomeBotaoTabela;
        const onClickHandler = contratoMigrado ? telaComparacaoPosVendas : IniciarUpSellCompararPlanos;

        return (
            <div className='datatable-editar'>
                <ButtonUi
                    variant="text"
                    color="primary"
                    onClick={() => onClickHandler(rowData)}
                >
                    {nomeBotao}
                </ButtonUi>
            </div>
        );
    };

    return (
        <div>
            {!isLoading ? (
                <>
                    <Modal
                        open={openModalPlanos}
                        onClose={handleCloseModal}
                        disableEnforceFocus={false}
                        aria-labelledby="server-modal-title"
                        aria-describedby="server-modal-description"
                    >
                        <div className="modal-container">
                            <div className="modal-content">
                                <ModalPlanosCompativeis
                                    handleCloseModal={handleCloseModal}
                                    dadosVendedor={dadosVendedor}
                                    inscricao={isInscricao}
                                    contratoSelecionado={contratoSelecionado}
                                />
                            </div>
                        </div>
                    </Modal>
                    {contratos && (
                        <>
                            <Typography variant="h5" gutterBottom className='titulo-pagina-principal'>
                                {titulo}
                            </Typography>
                            <div className="datatable-responsive-demo">
                                <div className="card">
                                    <DataTable
                                        value={contratos}
                                        header={renderHeader()}
                                        className="p-datatable-responsive-demo"
                                        dataKey="id"
                                        emptyMessage="Adicione uma inscrição no filter para carregar os dados do plano."
                                    >
                                        <Column
                                            field="inscricao"
                                            header="Inscrição"
                                            headerStyle={{
                                                width: '7em',
                                                textAlign: 'center'
                                            }}
                                            body={inscricaoBodyTemplate}
                                        />
                                        <Column
                                            field="nome"
                                            header="Nome"
                                            body={nomeBodyTemplate}
                                        />
                                        <Column
                                            field="cpf"
                                            header="CPF"
                                            body={CPFBodyTemplate}
                                        />
                                        <Column
                                            field="telefone"
                                            header="Telefone"
                                            body={telefoneBodyTemplate}
                                        />
                                        <Column
                                            field="subGrupo"
                                            header="SubGrupo"
                                            body={subGrupoTemplate}
                                        />
                                        <Column
                                            field="status"
                                            header="Status UpSell"
                                            body={statusBodyTemplate}
                                        />
                                        <Column
                                            field="statusAceite"
                                            header="Status Aceite"
                                            body={statusAceiteBodyTemplate}
                                        />
                                        <Column
                                            exportable={false}
                                            field="Status"
                                            body={buttonBodyTemplate}
                                            header="Ações"
                                            className="Acoes"
                                        >
                                        </Column>
                                    </DataTable>
                                </div>
                            </div>
                        </>
                    )}
                </>
            ) : (
                <ProgressSrinnerUpSell />
            )}
        </div>
    );
}

export default ListarUpSell;
